import { EnvironmentModel } from "@keus-template/environment";

export const environment: EnvironmentModel = {
  production: false,
  apiUrl: "https://c1lwca9u0b.execute-api.eu-central-1.amazonaws.com",
  tenant: "default",
  s3: {
    url: "https://keus-dev-thalea-documents.s3.eu-central-1.amazonaws.com",
    profilePicPrefix: "profilePic",
    presignedUrl: "",
  },
  stripePriceId: "price_1SOENzHP1fJy4Z9UNzFJmgxA",
  stripePsychoPriceId: "price_1SOENzHP1fJy4Z9UNzFJmgxA",
  voluntaryConsultationPrice: 150,
  voluntaryPsychoConsultationPrice: 50,
  pkStripe:
    "pk_test_51N6hKcHP1fJy4Z9UNbkBog3LMPSrk5VjxRdFMVwhUspvKiKTuqlfkx5QV8nQq5lxcbARyDhXFpjBGLs92DWIoZBh00K9OVIhFX",
  cognito: {
    userPoolId: "eu-central-1_KlW2M8gQh",
    userPoolClientId: "2aqv6utlbf5ao47ru0v8f41l9",
    region: "eu-central-1",
    authDomain: "keus-dev-thalea-user-pool",
  },
  // Intercom configuration - Replace with your actual App ID
  intercomAppId: "msxarwpr",
};
